import React, { useEffect } from 'react';
import './BloodWorldPrivacyPolicy.css';

const BloodWorldPrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "Privacy Policy - Blood World";
    }, []);

    return (
        <div className="privacy-container">
            <div className="privacy-content">
                <header className="privacy-header">
                    <h1>Privacy Policy for Blood World</h1>
                    <p className="privacy-effective-date">Effective Date: December 24, 2025</p>
                </header>

                <section className="privacy-section">
                    <p>
                        SYS Manjeri West Zone ("we," "us," or "our") operates the Blood World mobile application (the "App").
                        We are committed to protecting your privacy and ensuring that your personal information is handled
                        in a safe and responsible manner.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>1. Information We Collect</h2>
                    <p>To provide our blood donation services, we may collect the following information:</p>
                    <ul>
                        <li><strong>Personal Identification Information</strong>: Name, phone number, and blood group.</li>
                        <li><strong>Role-Specific Data</strong>: If you are a manager or administrator, we may collect credentials and contact information necessary for managing the donor database.</li>
                        <li><strong>Third-Party Data</strong>: We use Google Firebase for authentication and database management. You can review Google's privacy policy at <a href="https://policies.google.com/privacy" className="privacy-link" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the collected information for the following purposes:</p>
                    <ul>
                        <li><strong>To Facilitate Blood Donation</strong>: Allowing users to find and contact blood donors or managers during urgent needs.</li>
                        <li><strong>Communication</strong>: Connecting users with the correct contact persons via phone calls.</li>
                        <li><strong>App Improvements</strong>: Understanding how the App is used to improve user experience.</li>
                        <li><strong>Security</strong>: Authenticating administrators and protecting against unauthorized access.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>3. Data Sharing and Disclosure</h2>
                    <p>We <strong>do not sell, trade, or rent</strong> your personal identification information to others. We share information only in the following limited circumstances:</p>
                    <ul>
                        <li><strong>Public Visibility</strong>: By registering as a donor, you understand that your name and phone number may be visible to other users seeking blood donations.</li>
                        <li><strong>Legal Requirements</strong>: We may disclose information if required to do so by law.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>4. Data Security</h2>
                    <p>
                        We implement a variety of security measures to maintain the safety of your personal information.
                        We use Firebase's secure infrastructure for data storage and authentication. However, no method
                        of transmission over the internet or mobile device is 100% secure.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>5. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access the personal information we hold about you.</li>
                        <li>Request the correction of inaccurate data.</li>
                        <li>Request the deletion of your data from our database.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>6. Children's Privacy</h2>
                    <p>Our App is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.</p>
                </section>

                <section className="privacy-section">
                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting
                        the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically
                        for any changes.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>8. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us:</p>
                    <ul>
                        <li><strong>Organization</strong>: SYS Manjeri West Zone</li>
                        <li><strong>Location</strong>: Manjeri, Malappuram, Kerala, India</li>
                    </ul>
                </section>

                <footer className="privacy-footer">
                    <p>&copy; {new Date().getFullYear()} Blood World. All rights reserved.</p>
                </footer>
            </div>
        </div>
    );
};

export default BloodWorldPrivacyPolicy;
